import { useEffect, useState } from "react"
import styles from "./Toggle.module.css"

const Toggle = ({checked = false, onChange = () => {}, loading=false, size='medium'}) => {

    const [check, setCheck] = useState(checked)

    useEffect(() => {
        setCheck(checked)
    },[checked])

    return (
        <label className={`${styles.toggle} ${styles[size]}`}>
            <input disabled={loading} type="checkbox" checked={check} className={styles.toggleInput} onChange={(e) => {
                setCheck(!check)
                onChange(e.target.checked)
            }}/>
            <span className={styles.slider}></span>
        </label>
    )
}

export default Toggle